import { GatewayClientProvider } from './../gateway-client/gateway-client';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';

/*
  Generated class for the BranchesProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class BranchesProvider {
  brancheslist = [];

  constructor(public gateway: GatewayClientProvider) {

  }

  getBranches(reload: boolean = false) {
    let self = this;
    return new Promise(function (resolve, reject) {
      if (reload) {
        self.gateway.getBranches()
          .then((data: any) => {
            self.brancheslist = data;
            resolve(self.brancheslist);
          }).catch((error) => {
            reject(error);
          })
      }
      else {
        resolve(self.brancheslist)
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/branches/branches.ts